import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function TickCircleIcon({ className, size = 24, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667ZM11.1869 6.52022C11.3821 6.32496 11.3821 6.00838 11.1869 5.81311C10.9916 5.61785 10.675 5.61785 10.4798 5.81311L7.16667 9.12623L5.52022 7.47978C5.32496 7.28452 5.00838 7.28452 4.81311 7.47978C4.61785 7.67504 4.61785 7.99162 4.81311 8.18689L6.81311 10.1869C7.00838 10.3821 7.32496 10.3821 7.52022 10.1869L11.1869 6.52022Z"
        fill="currentColor"
      />
    </svg>
  )
}
